import { Component, attr } from "../Component";
import {element} from "../CustomElement";
import { Page } from "../flipp-page/Page";
import { i18n } from "../../i18n/I18n";
import {inject} from "../../services/di";
import MetadataService from "../../services/MetadataService";
import {SeoDataService} from "../../services/SeoDataService";
import {isCrawler} from "../../utils/crawler";
import {LinkService} from "../../services/LinkService";

interface ICountryHomepage {
	topCities: string;
	withSidebar: string;
}

interface ILink {
	href: string;
	name: string;
}

interface ICity {
	name: string;
	state: string;
	topFlyers: ILink[];
	topCoupons: ILink[];
}

@element("flipp-country-homepage")
export class CountryHomepage extends Component<ICountryHomepage, {}> {
	@attr topCities: string;
	@attr withSidebar: string;
	@inject metadataService: MetadataService;
	@inject seoData: SeoDataService;
	@inject linkService: LinkService;

	renderLinks(links: ILink[]): HTMLElement {
		if (links.length === 0) {
			return <div></div>;
		}

		return (
			<ol>
				{links.map((link: ILink) => {
					const {href, name} = link;
					return <div>
						<li><a href={href}>{name}</a></li>
					</div>;
				})}
			</ol>
		);
	}

	renderCitySection({name, state, topFlyers, topCoupons}: ICity) {
		const fullCityName = name + "-" + state;

		return (
			<div>
				<a href={this.getCityLink(fullCityName)}>
					<h2>{name.replace("_", " ")}</h2>
				</a>
				<a href={this.getFlyersLink(fullCityName)}>
					<h3>Top Flyers</h3>
				</a>
				{this.renderLinks(topFlyers)}
				<a href={this.getCouponsLink(fullCityName)}>
					<h3>Top Coupons</h3>
				</a>
				{this.renderLinks(topCoupons)}
			</div>
		);
	}

	getCityLink(cityName: string): string {
		return `${this.getLocaleFromUrl()}/${this.cityNameToLink(cityName)}`;
	}

	getFlyersLink(cityName: string): string {
		return `${this.getCityLink(cityName)}/${this.metadataService.getLocaleBasedFlyerNames(this.getLocaleFromUrl())}s`;
	}

	getCouponsLink(cityName: string): string {
		return `${this.getCityLink(cityName)}/coupons`;
	}

	getLocaleFromUrl(): string {
		return window.location.pathname.replace("/", "");
	}

	cityNameToLink(cityName: string): string {
		return cityName.replace("_", "-").toLowerCase();
	}

	getTopMerchants() {
		return this.getLocaleFromUrl() === "en-us" ? this.seoData.getTopUsMerchants() : this.seoData.getTopCanadaMerchants();
	}

	renderMerchantsLinks() {
		if (!isCrawler()) {
			return null;
		}

		const links = this.getTopMerchants().map((merchant: string) => {
			return <ol><a href={this.linkService.getMerchantHref(merchant, this.getLocaleFromUrl())}>{merchant}</a></ol>;
		});
		return <div><ul>{links}</ul></div>;
	}

	render() {
		const topCities = JSON.parse(this.topCities);
		return (
			<Page show="flyers" withSidebar={this.withSidebar}>
				<h1>{i18n("index_page_h1")}</h1>
				{this.renderMerchantsLinks()}
				{topCities.map((city: ICity) => this.renderCitySection(city))}
			</Page>
		);
	}
}
